import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const Filter3Fill = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    title="Filter3Fill"
    {...props}
  >
    <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" />
  </svg>
);
export default React.memo(Filter3Fill);
